var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<div class=\"modal-inner\">\n<file-doctor-transfer class=\"file-doctor-transfer\" state=\"state\" target=\"target\" inner-mediator=\"innerMediator\"></file-doctor-transfer>\n</div>\n";
var id1="/app/realtime/components/file-transfer/modals/doctor/doctor.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;